// extracted by mini-css-extract-plugin
module.exports = {"topsAuthor":"TopAuthors_topsAuthor__Fl5Ln","slider":"TopAuthors_slider__1izyd"};